import RedirectScreen from "./RedirectScreen";

export default RedirectScreen;
